export const AttendeeDetailItem = [
  {
    walletAddress: 'J3PI7R66BXAN5AHC3H6LK7OOOHCU55VXC57S66FWMW4E7E6F',
    ticketTitle: 'RSVP',
    registrationDate: 'April 04, 2022  - 10.00PM',  
  },
  {
    walletAddress: 'J3PI7R66BXAN5AHC3H6LK7OOOHCU55VXC57S66FWMW4E7E6F',
    ticketTitle: 'RSVP',
    registrationDate: 'April 04, 2022  - 10.00PM',  
  },
  {
    walletAddress: 'J3PI7R66BXAN5AHC3H6LK7OOOHCU55VXC57S66FWMW4E7E6F',
    ticketTitle: 'RSVP',
    registrationDate: 'April 04, 2022  - 10.00PM',  
  },
  {
    walletAddress: 'J3PI7R66BXAN5AHC3H6LK7OOOHCU55VXC57S66FWMW4E7E6F',
    ticketTitle: 'RSVP',
    registrationDate: 'April 04, 2022  - 10.00PM',  
  },
  {
    walletAddress: 'J3PI7R66BXAN5AHC3H6LK7OOOHCU55VXC57S66FWMW4E7E6F',
    ticketTitle: 'RSVP',
    registrationDate: 'April 04, 2022  - 10.00PM',  
  },
]